import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/admin.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  hide = true;
  loading: boolean = false;
  userInfo: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private adminService: AdminService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.loginForm = this.fb.group({
      userID: ["", [Validators.required]],
      Password: ["", Validators.required],
      deviceID: [""],
      deviceToken: [""],
      devicetype: ["web"],
    })
  }
  //message alerts showing
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  forgotPassword() {
    let payload = { ...this.loginForm.value };
    if (payload.userID != "") {
      let plod = {
        userID: payload.userID
      }
      this.loading = true;
      this.adminService.forgotPassword(plod).subscribe((posRes: any) => {
        // console.log(posRes);
        this.loading = false;
        if (posRes.response == 3) {
          this.openSnackBar(posRes.message, "");
        } else {
          this.openSnackBar(posRes.message, "");
        }
      }, (err: HttpErrorResponse) => {
        console.log(err);
        this.loading = false;
        this.openSnackBar(err.message, "")
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error)
        } else {
          console.warn("Server Error", err.error)
        }
      })

    } else {
      this.openSnackBar("Enter UserID", "");
    }
  }


  submitDetails() {
    if (this.loginForm.valid) {
      this.loading = true;
      let payload = { ...this.loginForm.value };
      payload.deviceID = payload.userID;
      payload.deviceToken = "Web Token";
      console.log(payload);
      this.adminService.adminLogin(payload).subscribe((posRes: any) => {
        console.log(posRes);
        this.loading = false;
        if (posRes.response == 3) {
          this.userInfo = posRes.Info;
          if (this.userInfo && this.userInfo.RegisterType) {
            sessionStorage.setItem('isMainAdmin', '1')
          } else {
            sessionStorage.setItem('isMainAdmin', '0')
          }
          // sessionStorage.setItem('isMainAdmin','1');
          sessionStorage.setItem('token', posRes.Token);
          this.adminService.isAdminLoggedIn.next(true);
          sessionStorage.setItem('user', JSON.stringify(posRes.Info));
          localStorage.setItem('bguser',JSON.stringify(posRes.Info));
          this.router.navigate(['admin', 'dashboard'])
        } else {
          this.openSnackBar(posRes.message, "")
        }
      }, (err: HttpErrorResponse) => {
        console.log(err);
        this.loading = false;
        this.openSnackBar(err.message, "")
        if (err.error instanceof Error) {
          console.warn("Client Error", err.error)
        } else {
          console.warn("Server Error", err.error)
        }
      })
    } else {
      this.openSnackBar("Enter Valid User ID/Password", "")
    }
  }
  togglePasswordVisibility() {
    if (this.hide) {
      this.hide = false;
    } else {
      this.hide = true;
    }
  }
}
